import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import { Button, Form, Input, Modal } from "antd";

import { routeLogin } from "./../../config/api";
import { authActions } from "./../../redux/actions";

import "./LoginSplit.css";

const SPECIALIST_URL = "https://wa.me/554333383639?text=Ol%C3%A1%2C+gostaria+de+mais+informa%C3%A7%C3%B5es+sobre+a+Byponto.";

const WORDMARK_MASK = "url(/images/logos/byponto-wordmark.png)";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSending: false,
      error: "",
      redirectToReferrer: false,
    };
  }

  onFinish = (values) => {
    this.setState({ isSending: true });

    routeLogin(
      { action: "login", ...values },
      (response) => {
        this.setState({ isSending: false });
        const { type, ...success } = response;
        this.props.doLogin(success);
      },
      (error) => {
        this.setState({ isSending: false });
        Modal.error({
          title: "Ocorreu um erro!",
          content: String(error),
        });
      }
    );
  };

  render() {
    const { referrer } =
      this.props.location.state || { referrer: { pathname: "/" } };
    const { redirectToReferrer } = this.state;

    if (redirectToReferrer) {
      return <Redirect to={referrer} />;
    }

    return (
				<div className="auth-split__left-inner">
					{/* LOGO */}
					<div
						className="auth-logo"
						role="img"
						aria-label="ByPonto"
						style={{ WebkitMaskImage: WORDMARK_MASK, maskImage: WORDMARK_MASK }}
					/>

					{/* TÍTULO / SUB */}
					<h1 className="auth-title">
						Bem-vindo
					</h1>
					<p className="auth-sub">
						Gerencie o ponto dos seus colaboradores de forma simples e eficiente.
					</p>

					{/* FORM */}
					<Form
						ref={(el) => (this.form = el)}
						layout="vertical"
						scrollToFirstError
						onFinish={this.onFinish}
						className="auth-form"
					>
						<Form.Item
							name="email"
							label="E-mail"
							rules={[
								{ required: true, message: "Campo obrigatório." },
								{ type: "email", message: "Informe um e-mail válido." },
							]}
						>
							<Input
								prefix={<i className="fal fa-envelope" />}
								placeholder="seu@email.com"
								size="large"
								autoFocus
							/>
						</Form.Item>

						<Form.Item
							name="password"
							label="Senha"
							rules={[{ required: true, message: "Campo obrigatório." }]}
						>
							<Input.Password
								prefix={<i className="fal fa-lock" />}
								placeholder="••••••••"
								size="large"
							/>
						</Form.Item>

						<Button
							type="primary"
							htmlType="submit"
							size="large"
							block
							className="auth-submit"
							loading={this.state.isSending}
						>
							Entrar
						</Button>
					</Form>

					<div className="auth-recovery">
						<Link to="/recovery-password">Esqueceu sua senha?</Link>
					</div>

					<p className="auth-foot">
						Ainda não tem uma conta?{" "}
						<a href={SPECIALIST_URL} target="_blank" rel="noopener noreferrer">
							Fale com um especialista.
						</a>
					</p>
				</div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  doLogin: (data) => dispatch(authActions.login(data)),
});

export default connect(null, mapDispatchToProps)(Login);
